function APILoading() {
    return (
        <div className="w-full mx-auto flex items-center justify-center h-80">
            <img className="gif" src="https://fentepp.com.br/img/carregando.gif" alt="" />
        </div>
    );
}

export default APILoading;